module.exports = __webpack_public_path__ + "static/media/cq_home b.4f27804e.svg";